import type { NDateLocale } from './enUS'
import { enIN } from 'date-fns/locale'

const dateMlIN: NDateLocale = {
  name: 'ml-IN',
  locale: enIN
}

export default dateMlIN
